import { AlarmTypeGroupDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useAlarmTypeGroups(searchParams: string) {
  const url = `/v2/orm/alarmtype_groups?${searchParams}`;
  const request = new Request(url);

  return useAuthenticatedRequest<AlarmTypeGroupDTO>(request, {
    queryKey: ['alarm-type-groups', { searchParams }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      const payload = respJson.payload;

      if (payload && payload.items) {
        payload.items = payload.items.map((item: any) => ({
          alarmTypeGroupId: item.alarmtype_group_id,
          name: item.name,
          description: item.description,
          alarmTypes: (item.alarm_types || []).map((alarmType: any) => ({
            alarmTypeId: alarmType.id,
            name: alarmType.name,
          })),
        }));
      }

      return payload;
    },
  });
}

export default useAlarmTypeGroups;
